import React from 'react';
import { Box } from '@mui/material';
import VoiceCloningComponent from '../components/VoiceCloningComponent';

export default function VoiceCloning() {
  return (
    <Box sx={{ width: '100%', py: 2 }}>
      <VoiceCloningComponent />
    </Box>
  );
}
